<template>
  <div class="logs">
    <div class="logs__inputWrapper">
      <span>Date:</span>
      <div class="logs__selectDate" @click="openCalendar">
        <span>{{ valueDate }}</span>
      </div>
      <div id="app" class="logs__calendar" v-if="openedCalendar">
        <DatePicker
          v-on:input="getCorrectDate"
          v-bind:value="selectedDate"
          is-dark
          is-range
          :modelConfig="modelConfig"
          :select-attribute="selectDragAttribute"
          :drag-attribute="selectDragAttribute"
          @drag="dragValue = $event"
        >
          <template v-slot:day-popover="{ format }">
            <div>
              {{ format(dragValue ? dragValue.start : range.start, 'MMM D') }}
              -
              {{ format(dragValue ? dragValue.end : range.end, 'MMM D') }}
            </div>
          </template>
        </DatePicker>
      </div>
    </div>
    <div class="logs__tableWrapper">
      <div class="logs__loaderWrapper">
        <Loader class="logs__loader" v-if="loader" />
      </div>
      <table v-if="logs.length && !loader">
        <thead>
          <tr>
            <td>Admin_id</td>
            <td>User_id</td>
            <td>inc</td>
            <td>Date</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, key) in logs" :key="key">
            <td>{{ log.admin_id }}</td>
            <td>{{ log.user_id }}</td>
            <td class="inc">
              <span v-for="(value, cur) in log.inc" :key="cur">{{ `${cur} : ${value}` }}</span>
            </td>
            <td>{{ parseDate(log.datetime) }}</td>
          </tr>
        </tbody>
      </table>
      <p class="logs__empty" v-if="!logs.length && !loader">Записей нет</p>
    </div>
  </div>
</template>

<script>
import './logs.scss'

import Loader from '../../components/Loader/Loader'
import { DatePicker, Calendar } from 'v-calendar'

export default {
  name: 'Logs',
  components: {
    Loader,
    Calendar,
    DatePicker
  },
  data() {
    return {
      endDate: `&end=${new Date().toISOString().split('.')[0]}`,
      startDate: `start=${
        new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('.')[0]
      }`,
      logs: [],
      openedCalendar: false,
      selectedDate: new Date(),
      modelConfig: {
        type: 'string',
        mask: 'iso'
      },
      dragValue: null,
      range: {
        start: new Date(2018, 0, 8),
        end: new Date(2018, 0, 12)
      },
      valueDate: 'Выберите дату',
      loader: false
    }
  },
  computed: {
    selectDragAttribute() {
      return {
        popover: {
          visibility: 'hover',
          isInteractive: false
        }
      }
    }
  },
  mounted() {
    this.getLogsInfo()
  },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  methods: {
    getLogsInfo() {
      this.loader = true
      fetch(
        `https://auth.apineural.com/api/user/admin-balance-logs?${this.startDate}${this.endDate}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.loader = false
          this.logs = data.logs
        })
    },
    parseDate(date) {
      const d = new Date(date)

      d.setMinutes(d.getMinutes() + -d.getTimezoneOffset())

      return d.toLocaleString('ru-RU', {
        timeZone: 'Europe/Moscow',
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      })
    },
    getCorrectDate(e) {
      this.startDate = `start=${e.start.split('.')[0]}`
      this.endDate = `&end=${e.end.split('.')[0]}`
      this.valueDate = `${e.start.split('T')[0]} - ${e.end.split('T')[0]}`
      this.openedCalendar = false
      this.getLogsInfo()
    },
    openCalendar() {
      this.openedCalendar = true
    },
    closeByClickingSelect(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('logs__selectDate') || div.classList.contains('logs__calendar'))
        )
      ) {
        this.openedCalendar = false
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingSelect)
    }
  }
}
</script>
